export const REASON_KEYS = [
  'scheduling',
  'tracking',
  'team',
  'messenger',
  'payroll',
  'settings',
  'other',
];

export const SUBMIT_NEW_REQUEST_URL =
  'https://support.joinhomebase.com/s/contactsupport';

export const HELP_ARTICLE_URL = 'https://support.joinhomebase.com/s/article';
export const HELP_TOPIC_URL = 'https://joinhomebase.my.site.com/s/topic';

export const CONTACT_US_ARTICLE_URL = `${HELP_ARTICLE_URL}/Homebase-Support-Contact-Us`;
